<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="职位名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入职位名称"></Input>
      </FormItem>
      <FormItem label="职位代码" prop="value">
        <Input
          v-model="formValidate.value"
          placeholder="请输入职位代码"
        ></Input>
      </FormItem>
      <FormItem label="权限列表" prop="value">
        <Transfer
          :titles="['未选', '已选']"
          :data="data"
          :target-keys="formValidate.permissions"
          filterable
          :filter-method="filterMethod"
          @on-change="handleChange"
        ></Transfer>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],

      formValidate: {
        id: '',
        name: '',
        value: '',
        permissions: []
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '职位名称不能为空',
            trigger: 'blur'
          }
        ],
        value: [
          {
            required: true,
            message: '职位代码不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setData (permissionList) {
      var data = new Array()
      for (var i = 0; i < permissionList.length; i++) {
        data[i] = { key: permissionList[i].id, label: permissionList[i].name }
      }
      this.data = data
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.name = data.name
      this.formValidate.value = data.value
      this.formValidate.permissions = data.permissions
    },

    handleChange (newTargetKeys) {
      this.formValidate.permissions = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
